
    import __i18nConfig from '@next-translate-root/i18n'
    import __loadNamespaces from 'next-translate/loadNamespaces'
    // CSS Modules
import { Button, Flex, Heading } from '@chakra-ui/react';
import { GetServerSideProps } from 'next';
import { NextSeo } from 'next-seo';
import Image from 'next/image';
import useTranslation from 'next-translate/useTranslation';
import { useRouter } from 'next/router';
import { ONE_MINUTE_IN_SECONDS, TEN_SECONDS } from '@/constants/timeConstants';
import { GET_CONSULTANCYPAGE_DATA, GET_HEADER_DATA, GET_SERVICES_DATA, GET_FOOTER_DATA, GET_COOKIES, } from '@/graphql/queries';
import { breadcrumbInitial } from '@/data/breadcrumbInitial';
import { handleError } from '@/helpers/handleError';
import { BreadcrumbType } from '@/Types/types';
import { configFile } from '@/config';
import HeaderMenu from '@/components/HeaderMenu';
import Footer from '@/components/Footer';
import BannerCategoryTag from '@/components/BannerCategoryTag';
import ServicesBannerComponent from '@/components/ServicesPage/ServicesBannerComponent';
import HowItWorks from '@/components/ServicesPage/HowItWorks';
import AgileMethods from '@/components/ServicesPage/AgileMethods';
import MultiComponentAnimated from '@/components/MainPage/MultiComponentAnimated';
import Benefits from '@/components/ServicesPage/Benefits';
import ProjectScenarios from '@/components/ServicesPage/ProjectScenarios';
import { addApolloState, initializeApollo } from '@/lib/apolloClient';
import { handleGTMClick } from '@/helpers/handleGTMClick';
export default function ConsultingSEOPage({ cookies, header, navbar, servicesData, breadcrumbs, footer, homepage, consultancyData, }: any) {
    const { t } = useTranslation('services');
    const router = useRouter();
    return (<>
      <HeaderMenu cookies={cookies.data} menu={header[0].items} submenu={navbar.data?.attributes.menu_header_list}/>
      <NextSeo title={consultancyData.data[0].attributes.metaTitle} description={consultancyData.data[0].attributes.metaDescription}/>
      <BannerCategoryTag title={consultancyData.data[0]?.attributes.title} description={consultancyData.data[0]?.attributes.content} breadcrumbs={breadcrumbs} button/>
      <Flex position="relative" left={{ base: '0', lg: '50%' }} transform={{ base: '', lg: 'translateX(-50%)' }} top={{ base: '0', lg: '-40px' }}>
        <ServicesBannerComponent data={servicesData.data}/>
      </Flex>
      <HowItWorks />
      <Flex w="100%" bgColor="teal.500" mb="32px">
        <Flex direction={{ base: 'column', lg: 'row' }} maxW="1216px" alignItems="center" justifyContent="space-between" m="0 auto" pt={{ base: '48px', lg: '112px' }} pb={{ base: '48px', lg: '112px' }} width={{ base: '90%', lg: '100%' }}>
          <Flex direction="column" gap="41px">
            <Flex justifyContent="space-between">
              <Heading fontSize={{ base: '36px', lg: '48px' }} lineHeight={{ base: '40px', lg: '48px' }} fontWeight="800" color={configFile.tertiaryAccentColor} textAlign={{ base: 'center', lg: 'left' }}>
                {t('seoConsulting.bannerSEO.title')}
              </Heading>
              <Button id="partners_contact" onClick={(e) => handleGTMClick(e, () => router.push('/contato'))} aria-label="contact page" size="lg" mt={{ base: '41px', lg: '0' }} display={{ base: 'none', lg: 'flex' }} color="#1A202C" bgColor={configFile.tertiaryAccentColor}>
                {t('seoConsulting.bannerSEO.button')}
              </Button>
            </Flex>
            <Flex gap="72px" w="100%" overflowX={{ base: 'scroll' }} css={{
            '&::-webkit-scrollbar': {
                display: 'none'
            },
            scrollbarWidth: 'none',
            msOverflowStyle: 'none'
        }} flexWrap={{ base: 'nowrap', lg: 'wrap' }}>
              {homepage.data.attributes.clients.data.length > 0 &&
            homepage.data.attributes.clients.data.map((client: any, index: number) => (<Image key={index} src={client.attributes.logo.data.attributes.url} alt={client.attributes.name} width={client.attributes.logo.data.attributes.width} height={client.attributes.logo.data.attributes.height} style={{ filter: 'invert(100%) grayscale(100%)' }}/>))}
            </Flex>
            <Button id="scenario_contact" onClick={(e) => handleGTMClick(e, () => router.push('/contato'))} aria-label="contact page" size="lg" display={{ base: 'flex', lg: 'none' }} color="#1A202C" bgColor={configFile.tertiaryAccentColor}>
              {t('seoConsulting.bannerSEO.button')}
            </Button>
          </Flex>
        </Flex>
      </Flex>
      <AgileMethods />
      <Benefits />
      <MultiComponentAnimated ectools items={[
            {
                title: `${t('seoConsulting.multiComponentAnimated.items.title1')}`,
                description: `${t('seoConsulting.multiComponentAnimated.items.description1')}`
            },
            {
                title: `${t('seoConsulting.multiComponentAnimated.items.title2')}`,
                description: `${t('seoConsulting.multiComponentAnimated.items.description2')}`
            },
            {
                title: `${t('seoConsulting.multiComponentAnimated.items.title3')}`,
                description: `${t('seoConsulting.multiComponentAnimated.items.description3')}`
            },
        ]}/>
      <ProjectScenarios />
      <Footer menu={footer[0].items}/>
    </>);
}
const getServerSideProps: GetServerSideProps = async ({ res }) => {
    try {
        res.setHeader('Cache-Control', `public, s-maxage=${TEN_SECONDS}, stale-while-revalidate=${ONE_MINUTE_IN_SECONDS}`);
        const client = initializeApollo();
        const { data: headerData } = await client.query({
            query: GET_HEADER_DATA
        });
        const { data: footerData } = await client.query({
            query: GET_FOOTER_DATA
        });
        const { data: cookiesData } = await client.query({
            query: GET_COOKIES
        });
        const { data: servicesData } = await client.query({
            query: GET_SERVICES_DATA
        });
        const { data: consultancyData } = await client.query({
            query: GET_CONSULTANCYPAGE_DATA
        });
        const breadcrumbs: BreadcrumbType[] = JSON.parse(JSON.stringify(breadcrumbInitial));
        breadcrumbs.push({
            href: '/servicos',
            label: 'Serviços'
        });
        breadcrumbs.push({
            href: `/servicos/${consultancyData.consultancyData.data[0].attributes.url}`,
            label: `${consultancyData.consultancyData.data[0].attributes.title}`
        });
        return addApolloState(client, {
            props: {
                ...headerData,
                ...footerData,
                ...cookiesData,
                ...servicesData,
                ...consultancyData,
                breadcrumbs
            }
        });
    }
    catch (error) {
        handleError(error, 'Index getServerSideProps');
        return {
            notFound: true
        };
    }
};

    async function __Next_Translate__getServerSideProps__1977faa01a9__(ctx) {
      const res = await getServerSideProps(ctx)
      return {
        
        ...res,
        props: {
          ...(res.props || {}),
          ...(await __loadNamespaces({
            ...ctx,
            ...__i18nConfig,
            pathname: '/servicos/consultoria-em-seo/index',
            loaderName: 'getServerSideProps',
            loadLocaleFrom: typeof __i18nConfig.loadLocaleFrom === 'function' ? __i18nConfig.loadLocaleFrom : (l, n) => import(`@next-translate-root/locales/${l}/${n}`).then(m => m.default),
          }))
        }
      }
    }
    export { __Next_Translate__getServerSideProps__1977faa01a9__ as getServerSideProps }
  